(function (global) {

  // Регистрирует событие на смену значения типа папки для мобильной версии.
  function registerDisableShowUnreadControlForMobile(kindsToDisable, noKey) {
    $(function () {
      $('select[id$="Kind"]').change(function () {
        disableShowUnreadControl($(this).val(), kindsToDisable, noKey);
      });
    });
  }

  // Делает неактивным поле "Показывать число непрочитанных заданий", если выбрано неположенное значение.
  function disableShowUnreadControl(selectedKey, kindsToDisable, noKey) {
    var jShowUnreadControl = getShowUnreadControl();
    var showUnreadPick = jShowUnreadControl.data('DropDownListInstance');
    if ($.inArray(selectedKey, kindsToDisable) === -1) {
      if (showUnreadPick) {
        // Для обычной версии.
        showUnreadPick.disable();
        showUnreadPick.setValue(noKey);
      } else {
        // Для мобильной версии.
        getShowUnreadControl().val(noKey).attr('disabled', true).addClass('Req_Disabled');
      }
    } else {
      if (showUnreadPick) {
        // Для обычной версии.
        showUnreadPick.enable();
      } else {
        // Для мобильной версии.
        getShowUnreadControl().attr('disabled', false).removeClass('Req_Disabled');
      }
    }
  }

  // Получает контрол "Показывать число непрочитанных заданий".
  function getShowUnreadControl() {
    var r = $('.ShowUnreadContainer').find('input.pickField');
    if (r.length === 0) {
      // Для мобильной версии.
      r = $('select[id$="ShowUnread"]');
    }
    return r;
  }

  /**
   * Установить доступность кнопок на ленте при изменении формы папки.
   * @since 5.5.2201
   */
  global.bindButtonsEnablingOnFormChange = () => {
    const buttonNames = [ 'Save', 'SaveAndClose' ];
    const jMainContainerInputs = $('#main_container').find('input, textarea, select');
    const initialSerializedValues = jMainContainerInputs.serialize();
    switch (WA.CR.sideBar.tabs.current.name) {
      case 'Card':
        jMainContainerInputs.bind('change keyup', () => {
          if (jMainContainerInputs.serialize() !== initialSerializedValues) {
            Core.cards.enableButtonsOnFormChange(buttonNames);
          }
        });
        break;
      case 'RightsList':
        $('.Rights').on('rightsChange', () => {
          Core.cards.enableButtonsOnFormChange(buttonNames);
        });
        break;
    }
  };

  // Exports
  global.RegisterDisableShowUnreadControlForMobile = registerDisableShowUnreadControlForMobile;
  global.DisableShowUnreadControl = disableShowUnreadControl;

})(window);
